import React from 'react';
import { GelRowLayout, GelColumnLayout, GelContainerLite } from '@tal-gel/components';
import { get,has, isEmpty } from 'lodash';
import { defaultH3Text, boldLabel, subSectionMinHeight, subSectionTitle, tableHeaderText, tableBodyOddRow, tableBodyEvenRow, tableBodyText, pointerCursor } from '../Shared/Styles';

export default function PolicyExclusion(props) {
    let policyExclusion;
    let hasLoading = true;
    let hasAnyExclusions = true;
    let hasAnyOFBenefitsForInForcePolicy = false;
    let coverDetail;
    var policyStatus =  get(props.policyDetails, 'policy.status', '');

    if (!props.policyExclusion || isEmpty(props.policyExclusion) ||
        !props.policyLife || isEmpty(props.policyLife)) {
        policyExclusion = [0];
    } else {
        for (let i = 0; i < props.policyExclusion.length; i++) {
            policyExclusion = props.policyExclusion.filter(p => {
                return p.lifeNo === props.policyLife.lifeNo;
            });
        }

        hasAnyExclusions = policyExclusion.find(
            p => (has(p, 'exclusionSubject1') && p.exclusionSubject1 != null && p.exclusionSubject1 !== "")
                || (has(p, 'exclusionSubject2') && p.exclusionSubject2 != null && p.exclusionSubject2 !== "")
                || (has(p, 'exclusionWording') && p.exclusionWording != null && p.exclusionWording !== "")
                || (has(p, 'hasExclusion') && p.hasExclusion != null && p.hasExclusion)
        ) !== undefined;

        hasLoading = policyExclusion.find(
            p => (has(p, 'percentageLoading') && p.percentageLoading != null && p.percentageLoading !== "")
                || (has(p, 'perMilleLoading') && p.perMilleLoading != null && p.perMilleLoading !== "")
        ) !== undefined;

        coverDetail = props.coverDetails.filter(p=>{ return p.lifeNo === props.policyLife.lifeNo});

        hasAnyOFBenefitsForInForcePolicy = coverDetail.find(
            p => (has(p, 'coverStatusName') && p.coverStatusName != null && p.coverStatusName !== 'In Force')) !== undefined &&  policyStatus === 'In Force';  
       
    }

    return (
        <GelContainerLite style={subSectionMinHeight}>
            <GelRowLayout gutter="medium" style={subSectionTitle}>
                <h3 style={defaultH3Text} data-testid="policyExclusionLabel">Policy Exclusions</h3>
            </GelRowLayout>
            <GelRowLayout gutter="medium" style={tableHeaderText}>
                <GelColumnLayout distribution="1/3 1/3 1/3">
                    <div style={boldLabel}>Benefit</div>
                    <div style={boldLabel}>Has Exclusion(s)</div>
                    {/* <div style={boldLabel}>Exclusion Name</div>
                    <div style={boldLabel}>Exclusion Description</div> */}
                </GelColumnLayout>
            </GelRowLayout>
            {((!hasAnyExclusions) || (hasAnyOFBenefitsForInForcePolicy)) ?
                <GelRowLayout gutter="medium" style={tableBodyEvenRow}>
                    <GelColumnLayout distribution="1/3 1/3 1/3">
                        <div>There are no Exclusions to display</div>
                    </GelColumnLayout>
                </GelRowLayout>
                : policyExclusion.map((policyExclusion, index) =>
                    <div key={index}>
                        <GelRowLayout gutter="medium" style={(index % 2 === 0) ? tableBodyEvenRow : tableBodyOddRow}>
                            <GelColumnLayout distribution="1/3 1/3 1/3">
                                <div data-testid="benefitName" style={tableBodyText}>
                                    {(has(policyExclusion, 'benefitName')) ? policyExclusion.benefitName : ""}
                                </div>
                                <div data-testid="hasExclusion" style={pointerCursor}>
                                    {(has(policyExclusion, 'hasExclusion')) && policyExclusion.hasExclusion ? "Yes" : "No"}
                                    &nbsp;</div>
                                {/* <div data-testid="exclusionSubject" style={tableBodyText}>
                                    {(has(policyExclusion, 'ExclusionSubject1')) ? policyExclusion.ExclusionSubject1 : ""}
                                    {(has(policyExclusion, 'ExclusionSubject2')) ? policyExclusion.ExclusionSubject2 : ""}
                                    &nbsp;</div>
                                <div data-testid="exclusionWording" onClick={() => props.toggleDisplayExclusionWordingShort(policyExclusion)} style={pointerCursor}>
                                    {(policyExclusion.DisplayExclusionWordingShort) ? policyExclusion.ExclusionWordingShort : policyExclusion.ExclusionWording}
                                    &nbsp;</div> */}
                            </GelColumnLayout>
                        </GelRowLayout>
                    </div>
                )}
            <br />
            <GelRowLayout gutter="medium" style={subSectionTitle}>
                <h3 style={defaultH3Text} data-testid="policyExclusionLabel2">Policy Loadings</h3>
            </GelRowLayout>
            <GelRowLayout gutter="medium" style={tableHeaderText}>
                <GelColumnLayout distribution="1/3 1/3 1/3">
                    <div style={boldLabel}>Benefit</div>
                    <div style={boldLabel}>Percentage Loading</div>
                    <div style={boldLabel}>Per Mille Loading</div>
                </GelColumnLayout>
            </GelRowLayout>
          {/* TACO 5544 loadings should load if there is no exclusions */}
             {((!hasLoading) || (hasAnyOFBenefitsForInForcePolicy)) ?
                <GelRowLayout gutter="medium" style={tableBodyEvenRow}>
                    <GelColumnLayout distribution="1/3 1/3 1/3">
                        <div>There are no Loadings to display</div>
                    </GelColumnLayout>
                </GelRowLayout>
                :
                policyExclusion.map((policyExclusion, index) =>
                    <div key={index}>
                        <GelRowLayout gutter="medium" style={(index % 2 === 0) ? tableBodyEvenRow : tableBodyOddRow}>
                            <GelColumnLayout distribution="1/3 1/3 1/3">
                                <div data-testid="benefitName" style={tableBodyText}>
                                    {(has(policyExclusion, 'benefitName')) ? policyExclusion.benefitName : ""}
                                </div>
                                <div data-testid="percentageLoading" style={tableBodyText}>{(has(policyExclusion, 'percentageLoading')) ? policyExclusion.percentageLoading : ""}&nbsp;</div>
                                <div data-testid="perMilleLoading">{(has(policyExclusion, 'perMilleLoading')) ? policyExclusion.perMilleLoading : ""}&nbsp;</div>

                            </GelColumnLayout>
                        </GelRowLayout>
                    </div>
                )}
        </GelContainerLite>
    );

}